// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"5341ce05","739":"a3e102cf"}[chunkId] + ".chunk.js";
};